
export function updateStatistics(ctx, files) {
    const stats = {
        total: files.length,
        byFormat: {},
        byCategory: {},
        totalSize: 0
    };

    files.forEach(file => {
        // Count by format
        stats.byFormat[file.format] = (stats.byFormat[file.format] || 0) + 1;

        // Count by category
        if (file.category) {
            stats.byCategory[file.category] = (stats.byCategory[file.category] || 0) + 1;
        }

        // Sum size
        stats.totalSize += file.size || 0;
    });

    // Update UI elements
    const totalElement = document.getElementById('total-files');
    if (totalElement) {
        totalElement.textContent = stats.total;
    }

    const sizeElement = document.getElementById('total-size');
    if (sizeElement) {
        sizeElement.textContent = formatFileSize(stats.totalSize);
    }

    // Update breakdowns
    updateFormatBreakdown(ctx, stats.byFormat);
    updateCategoryBreakdown(ctx, stats.byCategory);
}

export function formatFileSize(bytes) {
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let size = bytes;
    let unitIndex = 0;

    while (size >= 1000 && unitIndex < units.length - 1) {
        size /= 1000;
        unitIndex++;
    }

    return `${size.toFixed(2)} ${units[unitIndex]}`;
}

export function updateFormatBreakdown(ctx, formatStats) {
    const container = document.getElementById('format-breakdown');
    if (!container) return;
    // Implementation placeholder: update DOM with format statistics
}

export function updateCategoryBreakdown(ctx, categoryStats) {
    const container = document.getElementById('category-breakdown');
    if (!container) return;
    // Implementation placeholder: update DOM with category statistics
}


